import React, { CSSProperties } from 'react';
import './style.scss';

interface Props {
    value: string;
    style?: CSSProperties;
}

const ChatUserMessage: React.FC<Props> = (props: Props) => {
    const { value, style } = props;

    return (
        <div className="chat-user-message" style={style}>
            <div className="message-container">{value}</div>
        </div>
    );
};

export default ChatUserMessage;
